import {
  Card,
  CardBody,
} from 'react-bootstrap'

const CardX = (props) => (
  <Card border={props.border} style={props.style} className={props.className}>
    <CardBody className="my-1">
      {props.children}
    </CardBody>
  </Card>
)
export default CardX
